// extracted by mini-css-extract-plugin
export default {"Container":"MiddleComp_Container__zaybx","Content":"MiddleComp_Content__pIbRW"};